export const getDynamicMaxLength = (width: number): number => {
  let dynamicMaxLength = 208;

  if (width >= 375 && width <= 475) {
    dynamicMaxLength = 310;
  } else if (width >= 476 && width <= 600) {
    dynamicMaxLength = 450;
  } else if (width >= 601 && width <= 700) {
    dynamicMaxLength = 610;
  } else if (width >= 701 && width <= 800) {
    dynamicMaxLength = 730;
  } else if (width >= 801 && width <= 900) {
    dynamicMaxLength = 850;
  } else if (width >= 901 && width <= 1023) {
    dynamicMaxLength = 1000;
  }

  return dynamicMaxLength;
};
